<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      {{ $t('common_words.farm_info') }}
    </p>
    <hr />
    <br />
    <div class="row">
      <div class="col-sm-6 col-lg-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.code')}: *`"
          v-model="model.code"
          name="common_words.code"
          v-validate="modelValidations.code"
          :error="getError('common_words.code', true)"
          placeholder="001"
        ></fg-input>
      </div>
      <div class="col-sm-6 col-lg-3 col-xl-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.cost_center')}:`"
          v-model="model.cost_center"
          name="common_words.cost_center"
          v-validate="modelValidations.cost_center"
          :error="getError('common_words.cost_center', true)"
          placeholder="0011"
        ></fg-input>
      </div>
      <div class="col-md-6 col-lg-4 col-xl-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('common_words.farm_inpute_name')}...`"
        ></fg-input>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-2 col-xl-2">
        <label>{{ $t('common_words.area_unit') }}: </label>
        <br />
        <el-select
          class="select-primary shadow-sm w-100"
          size="large"
          v-model="model.area_unit"
          :placeholder="`${$t('common_words.select')}...`"
          @change="emitAreaUnit"
        >
          <el-option
            class="select-primary"
            value="ha"
            :label="$t('common_words.hectare')"
          ></el-option>
          <el-option
            class="select-primary"
            value="ac"
            :label="$t('common_words.acres')"
          ></el-option>
        </el-select>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-2 col-xl-2">
        <fg-input
          :precision="2"
          :step="0.01"
          type="number"
          v-model="model.area"
          :label="`${$t('common_words.farm_size')} (${model.area_unit}) *`"
          v-validate="modelValidations.area"
          :error="getError('common_words.farm_size', true)"
          name="common_words.farm_size"
          placeholder="4.3"
        ></fg-input>
      </div>
      <div class="col-12">
        <fg-input
          type="email"
          :label="$t('common_words.principal_email')"
          placeholder="xxxx@gmail.com"
          v-model="model.email_notification"
          name="common_words.principal_email"
          v-validate="'email'"
          :error="getError('common_words.principal_email', true)"
        ></fg-input>
      </div>
      <div class="col-12">
        <fg-input
          type="email"
          :label="$t('common_words.secondary_email')"
          placeholder="xxxx@gmail.com"
          v-model="model.email_notification_two"
          name="common_words.secondary_email"
          v-validate="'email'"
          :error="getError('common_words.secondary_email', true)"
        ></fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <select-businesses-component
          ref="select-businesses"
          :showLoading="true"
          :requiered="true"
          :initialData="businessesInitial"
          @onChange="updateSelectedBusinesses"
          @showHideLoading="showHideLoading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  data() {
    return {
      model: {
        id: null,
        name: null,
        code: null,
        cost_center: null,
        area: null,
        area_unit: 'ha',
        email_notification: null,
        email_notification_two: null,
        businesses_id: [],
      },
      modelValidations: {
        name: {
          required: true,
        },
        area: {
          required: false,
        },
        code: {
          required: true,
        },
        cost_center: {
          max: 11,
        },
      },
      businesses: null,
      businessesInitial: [],
    };
  },
  mixins: [MixinPermissions, MixinForm, MixinMasters, MixinAlert, MixinLoading],
  methods: {
    emitAreaUnit() {
      this.$emit('emit-methods', 'setAreaUnit', this.model.area_unit);
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
    },
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          if (!res) return res;
          if (!isset(this.model.businesses_id)) {
            this.validationInputsRequired('bus-rels', false, true);

            return false;
          } else return res;
        })
        .then((resp) => {
          this.$emit('on-validated', {
            ...this.model,
            names_business: this.businesses
              .filter((business) =>
                this.model.businesses_id.includes(business.id)
              )
              .map((business) => business.name),
          });

          return resp;
        });
    },
  },

  mounted() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('businesses/only')
        .then((response) => {
          this.businesses = this.concatAll(response.data.data);
          if (sessionStorage.getItem('editForm')) {
            const {
              id,
              code,
              cost_center,
              name,
              area,
              area_unit,
              email_notification,
              email_notification_two,
              businesses,
            } = JSON.parse(sessionStorage.getItem('editForm'));

            this.model = {
              id,
              code,
              cost_center,
              name,
              area,
              area_unit,
              email_notification,
              email_notification_two,
              businesses_id: businesses.map((element) => element.id),
            };
            this.$set(
              this,
              'businessesInitial',
              businesses ? businesses : business
            );

            this.showHideLoading();
          }
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
<style></style>
